import Vue from "vue";
import set from "lodash/set";
import get from "lodash/get";
import AdobeFunctions from "@/pixels/providers/utils/adobeFunctions";

const Adobe = {
  enable() {},
  wait() {
    return !(
      window._satellite === undefined || document.readyState !== "complete"
    );
  },
  init(context) {
    AdobeFunctions.internal(context, () => {
      Vue.$log.info("🚀 Adobe Launch working");
    });
  },

  // Eventos de CLICK
  appStartedClick(context) {
    AdobeFunctions.internal(context, () => {
      set(window.digitalData, "application.step", context.mutation.payload);
      AdobeFunctions.setPageName("1 verificacion");
      AdobeFunctions.callAdobeDTM("digitalLink", "App Started");
    });
  },
  internalLink(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      set(
        window.digitalData,
        "page.pageActivity.link.name",
        get(context.mutation.payload, "name", "")
      );
      AdobeFunctions.setPageName("pagina exitosa");
      AdobeFunctions.callAdobeDTM("digitalLink", "Internal Link");
    });
  },

  // Eventos de CARGA
  // Landing
  paso1(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setPageName("1 verificacion");
      set(window.digitalData, "application.step", "1 verificacion");
      AdobeFunctions.callAdobeDTM("digitalView", "App Page Visit");
    });
  },

  // Pasos
  paso2(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setProfileID(context);
      AdobeFunctions.setPageName("2 campanas");
      set(window.digitalData, "application.step", "2 campanas");
      AdobeFunctions.callAdobeDTM("digitalView", "App Step 2");
    });
  },
  paso3(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setTypology(context);
      AdobeFunctions.setProfileID(context);
      AdobeFunctions.setPageName("3 eleccion premios");
      set(window.digitalData, "application.step", "3 eleccion premios");
      AdobeFunctions.callAdobeDTM("digitalView", "App Step 3");
    });
  },
  paso4(context) {
    AdobeFunctions.internal(context, () => {
      AdobeFunctions.clearVars();
      AdobeFunctions.setOffer(context);
      AdobeFunctions.setTypology(context);
      AdobeFunctions.setProfileID(context);
      AdobeFunctions.setPageName("pagina exitosa");
      set(window.digitalData, "application.state", "finalizado");
      set(window.digitalData, "application.step", "pagina exitosa");
      AdobeFunctions.callAdobeDTM("digitalView", "App Completed");
    });
  },

  // Huellas
  mensaje(context) {
    AdobeFunctions.internal(context, () => {
      const tipoError = get(context, "state.tipoError");
      const profile = {
        33090063: "cliente sin campañas para referir",
        CLE075: "cliente inexistente"
      };
      switch (context.mutation.payload.params.mje) {
        case "mensaje-1":
        case "mensaje-2":
          AdobeFunctions.setProfileID(context);
          AdobeFunctions.setPageName("pagina exitosa");
          set(window.digitalData, "application.state", "rechazado");
          set(window.digitalData, "application.step", "pagina exitosa");
          set(
            window.digitalData,
            "user.segment.profile",
            profile[tipoError] || ""
          );

          AdobeFunctions.callAdobeDTM("digitalView", "App Completed");
          break;
        default:
          AdobeFunctions.clearVars();
          AdobeFunctions.setProfileID(context);
          AdobeFunctions.setPageName("error servicio no disponible");
          set(
            window.digitalData,
            "page.pageInfo.errorPage",
            "error servicio no disponible"
          );
          AdobeFunctions.callAdobeDTM("digitalView", "Page View");
      }
    });
  }
};

export default Adobe;
